/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';
import classNames from 'classnames';
import ChevronDownIcon from 'mdi-react/ChevronDownIcon';
import ChevronUpIcon from 'mdi-react/ChevronUpIcon';
import { Link } from 'react-router-dom';
import LazyLoad from 'react-lazyload';
import { FiCameraOff } from 'react-icons/fi';
import { NewOrderTableProps } from '../../../../../../shared/prop-types/TablesProps';
import Panel from '../../../../../../shared/components/Panel';
import {
  formatFixedTwoPercent, currencyFormatter, formatNumberDefaultToZero,
} from '../../../../../../shared/components/table/functions';
import { Theme } from '../../../../../../shared/prop-types/MainProps';
import {
  getTableHeaderStyle,
  getTableRowStyle,
  getTableWrapperStyle,
  isDarkTheme,
} from '../../../../../../shared/helpers/themeTableStyles';

const BestsellersBars = ({ quantity }) => {
  const amountClass = classNames({
    'dashboard__table-bestsellers': true,
    'dashboard__table-bestsellers--high': quantity > 100,
    'dashboard__table-bestsellers--medium': quantity <= 100,
    'dashboard__table-bestsellers--low': quantity <= 20,
  });
  if (quantity > 150) {
    return (
      <div className={amountClass}>
        <div />
        <div />
        <div />
        <div />
        <div />
        <span>{formatNumberDefaultToZero({ value: quantity })}</span>
      </div>
    );
  } if (quantity > 100) {
    return (
      <div className={amountClass}>
        <div />
        <div />
        <div />
        <div />
        <span>{formatNumberDefaultToZero({ value: quantity })}</span>
      </div>
    );
  } if (quantity > 50) {
    return (
      <div className={amountClass}>
        <div />
        <div />
        <div />
        <span>{formatNumberDefaultToZero({ value: quantity })}</span>
      </div>
    );
  } if (quantity > 20) {
    return (
      <div className={amountClass}>
        <div />
        <div />
        <span>{formatNumberDefaultToZero({ value: quantity })}</span>
      </div>
    );
  }
  return (
    <div className={amountClass}>
      <div />
      <span>{formatNumberDefaultToZero({ value: quantity })}</span>
    </div>
  );
};

BestsellersBars.propTypes = {
  quantity: PropTypes.number,
};

BestsellersBars.defaultProps = {
  quantity: 0,
};

const PpcBestsellers = ({
  newOrder, title, subhead, initalLoad, showingAll, toggleDisplay, pivotOn, handleCheckboxChange, checkedItem, graphLoad, theme,
}) => {
  const iconStyle = { width: 40, height: 40 };
  const isDarkMode = isDarkTheme(theme);

  return (
    <Panel
      lg={12}
      md={12}
      title={title}
      subhead={subhead}
      parentRefresh={initalLoad}
    >
      <div style={getTableWrapperStyle(isDarkMode)}>
        <Table responsive className="dashboard__table-orders" id="top10">
          <thead style={{ backgroundColor: isDarkMode ? '#232531' : '#f8f9fa' }}>
            <tr>
              <th style={getTableHeaderStyle(isDarkMode)}>GRAPH</th>
              {(pivotOn === 'ASIN') && (
                <th style={getTableHeaderStyle(isDarkMode)}>Image</th>
              )}
              {(pivotOn === 'ASIN') && (
                <th style={getTableHeaderStyle(isDarkMode)}>ASIN</th>
              )}
              {!(pivotOn === 'ASIN') && (
                <th style={getTableHeaderStyle(isDarkMode)}>{pivotOn.split('_').join(' ')}</th>
              )}
              {(pivotOn === 'ASIN') && (
                <th style={getTableHeaderStyle(isDarkMode)}>SKU</th>
              )}
              {(pivotOn === 'ASIN') && (
                <th style={getTableHeaderStyle(isDarkMode)}>Product Title</th>
              )}
              <th style={getTableHeaderStyle(isDarkMode)}>Impressions</th>
              <th style={getTableHeaderStyle(isDarkMode)}>Clicks</th>
              <th style={getTableHeaderStyle(isDarkMode)}>PPC Spend</th>
              <th style={getTableHeaderStyle(isDarkMode)}>PPC Sales</th>
              <th style={getTableHeaderStyle(isDarkMode)}>PPC Units</th>
              <th style={getTableHeaderStyle(isDarkMode)}>Shipped Units</th>
              <th style={getTableHeaderStyle(isDarkMode)}>Shipped COGS</th>
              <th style={getTableHeaderStyle(isDarkMode)}>PACoS</th>
              <th style={getTableHeaderStyle(isDarkMode)}>ROAS</th>
            </tr>
          </thead>
          <tbody>
            {newOrder.map((order, index) => {
              const rowStyle = getTableRowStyle(isDarkMode, index % 2 === 1);
              return (
                <tr key={index} style={{ ...rowStyle, ...(index > 9 ? { display: (showingAll ? '' : 'none') } : {}) }}>
                  <td style={rowStyle}>
                    <input
                      id={order[pivotOn.toLowerCase()]}
                      type="checkbox"
                      checked={checkedItem.has([order[pivotOn.toLowerCase()]].toString()) ? 'checked' : ''}
                      onChange={handleCheckboxChange}
                      disabled={graphLoad}
                    />
                  </td>
                  {(pivotOn === 'ASIN') && order.smallImageUrl && (
                    <td style={rowStyle}>
                      <LazyLoad>
                        <img src={order.smallImageUrl} alt={order.asin} />
                      </LazyLoad>
                    </td>
                  )}
                  {(pivotOn === 'ASIN') && !order.smallImageUrl && (
                    <td style={rowStyle}>
                      <FiCameraOff className="ag-no-image-icon" style={iconStyle} alt="Image not available" />
                    </td>
                  )}
                  <td style={rowStyle}>{order[pivotOn.toLowerCase()]}</td>
                  {(pivotOn === 'ASIN') && (
                    <td style={rowStyle}>{order.sku}</td>
                  )}
                  {(pivotOn === 'ASIN') && (
                    <td style={rowStyle}>{order.product_title}</td>
                  )}
                  <td style={rowStyle}>
                    <BestsellersBars quantity={order.impressions} />
                  </td>
                  <td style={rowStyle}>
                    <BestsellersBars quantity={order.clicks} />
                  </td>
                  <td className="dashboard__table-orders-total" style={rowStyle}>{currencyFormatter({ value: order.spend })}</td>
                  <td className="dashboard__table-orders-total" style={rowStyle}>{currencyFormatter({ value: order.sales })}</td>
                  <td style={rowStyle}>
                    <BestsellersBars quantity={order.units} />
                  </td>
                  <td style={rowStyle}>
                    <BestsellersBars quantity={order.sourcing_shipped_units} />
                  </td>
                  <td className="dashboard__table-orders-total" style={rowStyle}>{currencyFormatter({ value: order.sourcing_shipped_cogs })}</td>
                  <td style={rowStyle}>{formatFixedTwoPercent({ value: order.pacos })}</td>
                  <td style={rowStyle}>{currencyFormatter({ value: order.roas })}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
      <br />
      <Link to="/amazon/vendor/ppc-bestsellers" onClick={toggleDisplay} className="dashboard__table-orders-link">{ showingAll ? (<div><span>Show Less</span><ChevronUpIcon /></div>) : (<div><span>Show All</span><ChevronDownIcon /></div>)}</Link>
    </Panel>
  );
};

PpcBestsellers.propTypes = {
  newOrder: NewOrderTableProps.isRequired,
  title: PropTypes.string.isRequired,
  subhead: PropTypes.string.isRequired,
  initalLoad: PropTypes.bool.isRequired,
  showingAll: PropTypes.bool.isRequired,
  toggleDisplay: PropTypes.func.isRequired,
  pivotOn: PropTypes.string.isRequired,
  handleCheckboxChange: PropTypes.func.isRequired,
  // eslint-disable-next-line
  checkedItem: PropTypes.object.isRequired,
  graphLoad: PropTypes.bool.isRequired,
  theme: Theme.isRequired,
};

export default PpcBestsellers;
